import { render } from "./TabPhysical.vue?vue&type=template&id=b0bf6eac&scoped=true"
import script from "./TabPhysical.vue?vue&type=script&lang=js"
export * from "./TabPhysical.vue?vue&type=script&lang=js"

import "./TabPhysical.vue?vue&type=style&index=0&id=b0bf6eac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b0bf6eac"

export default script